<template>
    <v-container fluid class="b-container">
        <v-sheet v-if="showTabs" class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
                show-arrows
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize text-left text-md-center
                        justify-start justify-md-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/general/settings/billingDashboard";

export default {
    name: "RoadcubeMarket",

    mixins: [translations],

    data() {
        return {
            tab: this.$route.path
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "panelType",
            "permissions",
            "storePermissions",
            "store"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        showTabs() {
            return this.superUser && this.store.is_roadcube;
        },

        tabs() {
            let arr = [];
            if (this.showTabs) {
                arr.push({
                    name: {
                        el: "Συνδρομητικά προϊόντα",
                        en: "Subscription Products",
                        it: "Prodotti in abbonamento"
                    },
                    to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/subscription-products`
                });

                arr.push({
                    name: {
                        el: "Ιδιότητες",
                        en: "Attributes",
                        it: "Attributi"
                    },
                    to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/attributes`
                });
                arr.push({
                    name: {
                        el: "Επιλογές ιδιοτήτων",
                        en: "Attribute Options",
                        it: "Opzioni di attributi"
                    },
                    to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/attribute-options`
                });

                arr.push({
                    name: { el: "Παραλλαγές", en: "Variants", it: "Varianti" },
                    to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/variants`
                });
            }

            arr.push({
                name: { el: "Αγορά", en: "Shop", it: "Negozio" },
                to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/shop`
            });

            return arr;
        }
    },

    methods: {
        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),

        getPermission(path) {
            return (
                this.superUser ||
                (eval("this.permissions.roadcube_market." + path) &&
                    eval("this.storePermissions.roadcube_market." + path))
            );
        }
    },

    watch: {},

    mounted() {
        if (this.$route.name == "RoadcubeMarket") {
            if (this.showTabs) {
                this.$router.replace({
                    path: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/subscription-products`
                });
            } else {
                this.$router.replace({
                    path: `/${this.lang}/${this.panelType}/general-settings/roadcube-market/shop`
                });
            }
        }
    }
};
</script>
<style>
.relative {
    position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}
</style>
